import { DateTime } from "luxon";

/**
 * Returns an array of objects with `startDate` and `endDate` for the
 * current and previous two billing years.
 *
 * Billing year runs July 1 – June 30.
 * - If today >= July 1, "current" is July 1 THIS year → today.
 * - If today <  July 1, "current" is July 1 LAST year → today.
 */
export function getSchoolBillingDates() {
  const today = DateTime.now();
  const isAfterJuly = today.month > 6 || (today.month === 6 && today.day >= 1);

  const currentBillingStart = isAfterJuly
    ? DateTime.fromObject({ year: today.year, month: 7, day: 1 })
    : DateTime.fromObject({ year: today.year - 1, month: 7, day: 1 });

  // List out [start, end] for current, previous, two years ago
  return [
    {
      startDate: currentBillingStart,
      endDate: today,
    },
    ...[1, 2].map((n) => {
      const year = currentBillingStart.year - n;
      return {
        startDate: DateTime.fromObject({ year, month: 7, day: 1 }),
        endDate: DateTime.fromObject({ year: year + 1, month: 6, day: 30 }),
      };
    }),
  ];
}
